import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdblockplusComponent } from './simple-icons-adblockplus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdblockplusComponent ],
    exports:      [ SimpleIconsAdblockplusComponent ],
    bootstrap:    []
})
export class SimpleIconsAdblockplusModule {}
